"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiAccountFindQueryDto = void 0;
const billing_core_account_type_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-account-type.enum");
const billing_core_external_account_purpose_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-external-account-purpose.enum");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class BillingApiAccountFindQueryDto {
  /** Из похожего объекта или объекта того же типа */
  static fromLike(query) {
    if (query instanceof BillingApiAccountFindQueryDto) {
      return (0, class_transformer_1.instanceToInstance)(query);
    }
    const filter = new BillingApiAccountFindQueryDto();
    for (const key of Object.keys(query)) {
      filter[key] = query[key];
    }
    return filter;
  }
}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id контрагента для фильтрации по нему",
  type: 'string',
  format: 'uuid',
  isArray: true,
  items: {
    format: 'uuid'
  },
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4, {
  each: true
}), __metadata("design:type", Object)], BillingApiAccountFindQueryDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id провайдера",
  type: 'string',
  format: 'uuid',
  isArray: true,
  items: {
    format: 'uuid'
  },
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4, {
  each: true
}), __metadata("design:type", Object)], BillingApiAccountFindQueryDto.prototype, "providerId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Счета по типу",
  enum: billing_core_account_type_enum_1.BillingCoreAccountTypeEnum,
  isArray: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_account_type_enum_1.BillingCoreAccountTypeEnum, {
  each: true
}), __metadata("design:type", Object)], BillingApiAccountFindQueryDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Счета по назначению (относится только к внешним счетам с type=BANK)',
  enum: billing_core_external_account_purpose_enum_1.BillingCoreExternalAccountPurposeEnum,
  isArray: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_external_account_purpose_enum_1.BillingCoreExternalAccountPurposeEnum, {
  each: true
}), __metadata("design:type", Object)], BillingApiAccountFindQueryDto.prototype, "purpose", void 0);
exports.BillingApiAccountFindQueryDto = BillingApiAccountFindQueryDto;
